import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  makeStyles,
  tokens,
} from '@fluentui/react-components';
import { Title3, Button } from '@fluentui/react-components';
import { Add20Regular } from '@fluentui/react-icons';
import { useUsers } from '../../hooks/useUsers';
import { UserFull } from '../../types/user';
import UserGrid from './components/UserGrid';

const useStyles = makeStyles({
  container: {
    padding: tokens.spacingHorizontalXL,
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: tokens.spacingVerticalL,
  },
  title: {
    fontSize: tokens.fontSizeHero700,
    fontWeight: tokens.fontWeightBold,
  },
  addButton: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalS,
  },
  content: {
    backgroundColor: tokens.colorNeutralBackground1,
    borderRadius: tokens.borderRadiusLarge,
    boxShadow: tokens.shadow16,
    padding: tokens.spacingHorizontalXXL,
  },
});

const UserManagement: React.FC = () => {
  const styles = useStyles();
  const navigate = useNavigate();

  // Hook para operações de usuários (token é injetado automaticamente)
  const {
    users,
    usersLoading,
    userLoading,
    fetchUsers,
  } = useUsers();

  // Carregar usuários na montagem do componente, mas só após o usuário estar carregado
  React.useEffect(() => {
    if (!userLoading) {
      fetchUsers();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userLoading]);

  const handleNewUser = () => {
    navigate('/users/new');
  };

  const handleEditUser = (user: UserFull) => {
    navigate(`/users/edit?id=${user.id}`);
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Title3 className={styles.title}>Usuários</Title3>
        <Button
          appearance="primary"
          size="large"
          icon={<Add20Regular />}
          onClick={handleNewUser}
          className={styles.addButton}
        >
          Novo Usuário
        </Button>
      </div>

      <div className={styles.content}>
        <UserGrid
          users={users || []}
          onEdit={handleEditUser}
          onNew={handleNewUser}
          loading={usersLoading}
        />
      </div>
    </div>
  );
};

export default UserManagement;